<template>
  <div class="usageDetails">
    <commonHeader title="预算使用明细">
      <template #buttons>
        <el-button
          type="primary"
          v-if="detailsData.budget && Number(totalAmount-(detailsData.budget - detailsData.realBudget).toFixed(2)) !== 0"
          @click="budgetAdjustmentHandle"
        >调整预算</el-button>
        <!-- <button class="common_button" @click="backBtn">返回</button>-->
      </template>
    </commonHeader>
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/informationIcon.png" />
        <span>{{ detailsData.year }}年{{ detailsData.deptName }} - {{ detailsData.expenseTypeName }}</span>
      </div>
      <div class="common_readonly_template">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">总预算</div>
              <div class="text">{{ detailsData.budget }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">已使用预算</div>
              <div class="text">{{ (detailsData.budget - detailsData.realBudget).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">预算余额</div>
              <div class="text">{{ detailsData.realBudget }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">活动单据数量</div>
              <div class="text">{{ detailsData.activityNum }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">费用归属数量</div>
              <div class="text">{{ detailsData.expenseBelongNum }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">费用拆分单据（单）</div>
              <div class="text">{{ detailsData.expenseSplitNum }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">费用拆分金额</div>
              <div class="text">{{ detailsData.expenseSplitMoney }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">实际-占用预算</div>
              <div class="text">{{ actualBudget }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="exportHandle">导出</el-button>
      <el-button type="primary" @click="handleAdjustmentExpenses">费用部门调整</el-button>
    </div>
    <commonTable
      class="budgetUsageDetails"
      ref="budgetUsageDetails"
      :pageSizes="pageSizes"
      :table-row-class-name="tableRowClassNameHandle"
      @handleSelectChange="selectChangeCommand"
      @handleCheckBoxAll="selectChangeCommand"
    />
    <adjustmentExpensesDialog
      :details-data="detailsData"
      :selection-list="selectionList"
      :expenses-dialog-visible="expensesDialogVisible"
      @dialogCloseHandle="handleCloseDialog"
      @handleDeptNameSuccess="deptNameSuccessCommand"
    />
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { budgetPerformanceApi } from '../../service';
import adjustmentExpensesDialog from './adjustmentExpensesDialog.vue';

export default {
  data () {
    return {
      totalAmount: 0,
      detailsData: {},
      tableList: [],
      selectionList: [],
      expensesDialogVisible: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      pageSizes: [10, 50, 100, 500, 1000]
    };
  },
  computed: {
    actualBudget () {
      // 使用toFixed解决小数精度问题，但是会出现-0.00问题，使用parseFloat() || Math.abs()解决
      // https://www.zhihu.com/question/274243535/answer/373385686
      let total = (this.totalAmount - (this.detailsData.budget - this.detailsData.realBudget)).toFixed(2);
      total = parseFloat(total);
      if (isNaN(total)) {
        total = 0;
      }
      return total.toFixed(2);
    }
  },
  components: {
    commonHeader,
    commonTable,
    adjustmentExpensesDialog
  },
  methods: {
    handleAdjustmentExpenses () {
      if (this.selectionList.length <= 0) {
        this.$message.error('费用部门调整字段不能为空');
        return;
      }
      this.expensesDialogVisible = true;
    },
    // 费用部门调整关闭事件
    handleCloseDialog () {
      this.expensesDialogVisible = false;
    },
    // 费用部门调整成功事件
    deptNameSuccessCommand () {
      this.getDetailsData();
    },
    budgetAdjustmentHandle () {
      this.$confirm('是否确认调整预算金额?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          expenseDeptNameOrCode: this.$route.query.expenseDeptNameOrCode,
          expenseTypeCode: this.$route.query.expenseTypeCode,
          year: this.$route.query.year,
          adjustBudget: (this.totalAmount - (this.detailsData.budget - this.detailsData.realBudget)).toFixed(2)
        };
        budgetPerformanceApi.budgetAdjustment(params).then(res => {
          if (res.status === '200') {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getDetailsData();
          }
        });
      }).catch(() => {

      });
    },
    tableRowClassNameHandle ({ row, rowIndex, $rowIndex }) {
      return row.ifSplit === 1 ? 'ifSplit' : '';
    },
    exportHandle () {
      this.$message({
            message: '正在导出中...',
            type: 'success',
            duration: 2000
        });
      const list = this.selectionList.length <= 0 ? this.tableList : this.selectionList;
      let exportData = list.map(item => {
        let writeOffStatusText = '';
        switch (item.flowStat) {
                case 10:
                  writeOffStatusText = '审批中';
                  break;
                case 30:
                  writeOffStatusText = '待反馈';
                  break;
                case 40:
                  writeOffStatusText = '待核销';
                  break;
                case 50:
                  writeOffStatusText = '核销中';
                  break;
                case 55:
                  writeOffStatusText = '渠道核销驳回';
                  break;
                case 60:
                  writeOffStatusText = '核销结束';
                  break;
                case 65:
                  writeOffStatusText = '驳回';
                  break;
                case 101:
                  writeOffStatusText = '报备审批完成';
                  break;
                default:
                  writeOffStatusText = '废弃';
        }
        return {
          activityCode: item.activityCode,
          expenseBelongId: item.expenseBelongId,
          activityName: item.activityName,
          applyUserName: item.applyUserName,
          ifSplit: item.ifSplit ? '是' : '否',
          applyAmount: item.applyAmount,
          writeOffAmount: item.writeOffAmount,
          splitWriteOffAmount: item.splitWriteOffAmount,
          budget: item.budgetProcessing,
          writeOffStatus: writeOffStatusText,
          writeOffCode: item.writeOffCode,
          createTime: item.createTime,
          writeOffTime: item.writeOffTime,
          activityType: item.activityType,
          otherClassification: item.otherClassification,
          applyTime: item.applyTime,
          approvalTime: item.approvalTime
        };
      });
      let str = '<tr>' +
        '<td>活动编号</td>' +
        '<td>费用归属ID</td>' +
        '<td>活动名称</td>' +
        '<td>申请人</td>' +
        '<td>活动分摊</td>' +
        '<td>申请金额</td>' +
        '<td>核销金额</td>' +
        '<td>分摊金额</td>' +
        '<td>预算占用金额\r\n' + this.totalAmount + '</td>' +
        '<td>流程状态</td>' +
        '<td>核销单号</td>' +
        '<td>核销开始时间</td>' +
        '<td>核销结束时间</td>' +
        '<td>活动类型</td>' +
        '<td>申请分类</td>' +
        '<td>费用申请时间</td>' +
        '<td>费用审批完成时间</td>' +
        '</tr>';
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for (let i = 0; i < exportData.length; i++) {
        str += '<tr>';
        for (const key in exportData[i]) {
          str += `<td>${exportData[i][key] + '\t'}</td>`;
        }
        str += '</tr>';
      }
      const worksheet = 'Sheet1';
      const uri = 'data:application/vnd.ms-excel;base64,';
      let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body><table>${str}</table></body></html>`;
      let link = document.createElement('a');
      link.download = '预算执行情况明细.xls';
      link.style.display = 'none';
      link.href = uri + window.btoa(unescape(encodeURIComponent(template)));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    writeOffJump (row) {
      const lang = this.lang === 'zh-CN' ? 'zh' : 'en';
      const { sysUser } = this.$store.state.userInfo;
      const userId = sysUser.userId;
      const url = window._env_.VUE_APP_COST_SYSTEM_URL + row.expenseBelongId + `&lang=${lang}&uid=${userId}`;
      // let url = '';
      // if (this.lang === 'zh-CN') {
      //   url = window._env_.VUE_APP_EXPENSESYSTEM_URL + row.expenseBelongId;
      // } else {
      //   url = window._env_.VUE_APP_EXPENSESYSTEM_EN_URL + row.expenseBelongId;
      // }
      window.open(url);
    },
    detailsJump (row) {
      let path = '/activityDetails';
      if (row.reportType) {
        path = row.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
      } else {
        path = row.submitType === 'report_submit' ? '/reportDetails' : '/activityDetails';
      }
      this.$router.push({
        path,
        query: {
          activityCode: row.activityCode,
          metaActive: '/budgetPerformance'
        }
      });
    },
    backBtn () {
      this.$router.push({
        path: '/budgetPerformance'
      });
    },
    isShowWriteoff (data) {
      return data.some(item => {
        return item.writeOffStatus !== '0';
      });
    },
    // 多选change事件参数接收
    selectChangeCommand (e) {
      this.selectionList = e.selection;
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('6%')
          ._fixed('left')
          ._others('checkbox')
      );
      tableRow.push(
        new TableColumns()
          ._title('序号')
          ._width('70')
          ._others('seq')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动编号')
          ._data('activityCode')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{row.activityCode}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属ID')
          ._data('expenseBelongId')
          ._width('200')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动名称')
          ._data('activityName')
          ._width('200')
      );
      tableRow.push(
        new TableColumns()
          ._title('申请人')
          ._data('applyUserName')
          ._width('110')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动分摊')
          ._data('ifSplit')
          ._width('110')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{row.ifSplit === 1 ? '是' : '否'}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('申请金额')
          ._data('applyAmount')
          ._align('right')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('核销金额')
          ._data('applyWriteOffAmount')
          ._align('right')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('分摊金额')
          ._data('splitWriteOffAmount')
          ._align('right')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('预算占用金额\r\n' + this.totalAmount)
          ._data('budget')
          ._width('150')
          ._align('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{row.budgetProcessing}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('流程状态')
          ._data('writeOffStatus')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let StatusText = '';
              switch (row.flowStat) {
                case 10:
                  StatusText = '审批中';
                  break;
                case 30:
                  StatusText = '待反馈';
                  break;
                case 40:
                  StatusText = '待核销';
                  break;
                case 50:
                  StatusText = '核销中';
                  break;
                case 55:
                  StatusText = '渠道核销驳回';
                  break;
                case 60:
                  StatusText = '核销结束';
                  break;
                case 65:
                  StatusText = '驳回';
                  break;
                case 101:
                  StatusText = '报备审批完成';
                  break;
                default:
                  StatusText = '废弃';
              }
              return (
                <div>
                  <span>{StatusText}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('核销单号')
          ._data('writeOffCode')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.writeOffJump(row);
                  }}>{row.writeOffCode}</el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('核销开始时间')
          ._data('createTime')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('核销结束时间')
          ._data('writeOffTime')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动类型')
          ._data('activityType')
          ._width('150')
      );
       tableRow.push(
        new TableColumns()
          ._title('申请分类')
          ._data('otherClassification')
          ._width('150')
      );
      tableRow.push(
        new TableColumns()
          ._title('能否核销')
          ._data('ifSpecialWriteOff')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-switch
                    value={row.ifSpecialWriteOff === 1}
                    onChange={(res) => {
                      const params = {
                        expenseBelongId: row.expenseBelongId,
                        ifSpecialWriteOff: res ? 1 : 0
                      };
                      budgetPerformanceApi.setSpecialWriteOff(params).then(res => {
                        if (res.status === '200') {
                          this.getDetailsData();
                        }
                      });
                    }}
                  >
                  </el-switch>
                </div>
              );
            }
          })
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('拆分时间')
      //     ._data('splitTime')
      //     ._width('10%')
      // );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.budgetUsageDetails.setColumn(column);
        this.$refs.budgetUsageDetails.loadStaticTable(this.tableList, this.tableList.length);
      });
    },
    getDetailsData () {
      let params = {
        expenseDeptNameOrCode: this.$route.query.expenseDeptNameOrCode,
        expenseTypeCode: this.$route.query.expenseTypeCode,
        year: this.$route.query.year
      };
      this.$store.commit('setSubPageLoading', true);
      budgetPerformanceApi.getBudgetDetailsData(params).then(res => {
        if (res.status === '200') {
          this.detailsData = {
            ...res.data
          };
          this.tableList = res.data.mactWriteOffDTOList.map(item => {
            // 如果核销结束且费用拆分，则取拆分后的核销金额
            if (item.writeOffStatus === '2' && item.ifSplit === 1) {
              item.budgetProcessing = item.splitWriteOffAmount;
            } else if (item.writeOffStatus === '2' && item.ifSplit !== 1) {
              // 如果费用核销结束且没有拆分，取核销金额
              item.budgetProcessing = item.writeOffAmount;
            } else {
              // 其他情况取申请金额
              item.budgetProcessing = item.applyAmount;
            }
            return item;
          });
          this.totalAmount = this.tableList.reduce((current, item) => {
            return current + Number(item.budgetProcessing);
          }, 0);
          this.totalAmount = this.totalAmount.toFixed(2);
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    }
  },
  mounted () {
    this.getDetailsData();
  }
};
</script>

<style lang="scss" scoped>
.usageDetails {
  > .common_contentBox {
    ::v-deep.budgetUsageDetails .ifSplit span {
      color: #f56c6c !important;
    }
  }
}
</style>
